module.exports = __webpack_public_path__ + "static/media/forklift_inactive_sel.789f4800.svg";